export const routes = (parentName) => {
  return [
    {
      path: "shared",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-SharedCost`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "special",
          name: `${parentName}-SharedCost-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-SharedCost-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-SharedCost-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "SharedCost-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "SharedCost-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
